
export interface FailNotificationRequest {
  reason: string;
}
